import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Modal, Typography } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const GroundWaterInfo = () => {
  const { t } = useTranslation('input');
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button type="primary" icon={<InfoCircleOutlined />} onClick={() => setOpen(true)} style={{ marginBottom: 10 }}>
        {t('form.emissionReport.volumes.definitions.title')}
      </Button>
      <Modal title={t('form.emissionReport.volumes.definitions.title')} open={open} onOk={() => setOpen(false)} onCancel={() => setOpen(false)}>
        <Typography.Title level={5}>{t('form.emissionReport.volumes.definitions.feedTitle')}</Typography.Title>
        <Typography.Paragraph>{t('form.emissionReport.volumes.definitions.feed')}</Typography.Paragraph>
        <Typography.Title level={5}>{t('form.emissionReport.volumes.definitions.reuseTitle')}</Typography.Title>
        <Typography.Paragraph>{t('form.emissionReport.volumes.definitions.reuse')}</Typography.Paragraph>
      </Modal>
    </>
  );
};
